export default "__VITE_ASSET__99bd8e2a__"